import { render } from "./IDTagPaymentPaynow.vue?vue&type=template&id=f46e8f12&scoped=true"
import script from "./IDTagPaymentPaynow.vue?vue&type=script&lang=js"
export * from "./IDTagPaymentPaynow.vue?vue&type=script&lang=js"

import "./IDTagPaymentPaynow.vue?vue&type=style&index=0&id=f46e8f12&scoped=true&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f46e8f12"]])

export default __exports__